export default "__VITE_ASSET__C8V7Nh7l__"